if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (this.variantIdInput) {
           this.variantIdInput.disabled = false;
        }
        if (this.form) {
           this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this._lastAtcPriceText = '';

        // Direct-to-checkout: when the customer comes BACK from checkout,
        // reset the form so a restored pack-size / quantity isn't reused.
        this.resetAfterCheckoutReturn = () => {
          window.__vyveDirectCheckout = false;
          this._oneTimeSubmitting = false;
          if (this.submitButton) {
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.classList.remove('loading');
            const sp = this.querySelector('.loading__spinner');
            if (sp) sp.classList.add('hidden');
          }
          try {
            const sid = this.dataset.sectionId;
            const vs = sid ? document.getElementById(`variant-selects-${sid}`) : null;
            // Reset EVERY option (flavour, pack, etc.) to its first value —
            // browsers restore visually-hidden radios on Back, leaving the
            // old flavour checked underneath a UI that looks reset.
            const fieldsets = vs ? Array.from(vs.querySelectorAll('fieldset')) : [];
            let lastChanged = null;
            fieldsets.forEach((fs) => {
              const radios = Array.from(fs.querySelectorAll('input[type="radio"]'));
              const first = radios.find((r) => !r.disabled) || radios[0];
              if (first) {
                radios.forEach((r) => { r.checked = false; });
                first.checked = true;
                lastChanged = first;
              }
              const sel = fs.querySelector('select');
              if (sel && sel.options.length) { sel.selectedIndex = 0; lastChanged = sel; }
            });
            if (lastChanged) lastChanged.dispatchEvent(new Event('change', { bubbles: true }));
            const qty = this.form ? this.form.querySelector('input[name="quantity"]') : null;
            if (qty) { qty.value = qty.min || '1'; qty.dispatchEvent(new Event('change', { bubbles: true })); }
          } catch (err) {}
        };
        const checkReturn = (persisted) => {
          let returning = false;
          try {
            returning = sessionStorage.getItem('vyve_dc_return') === '1';
            if (returning) sessionStorage.removeItem('vyve_dc_return');
          } catch (err) {}
          if (!persisted && !returning) return;
          // Hard reload from the server so the PDP is in its default state —
          // no restored radios, no in-flight variant fetches, no stale
          // hidden inputs. Guarded so it can only fire once per return.
          if (window.__vyveReloading) return;
          window.__vyveReloading = true;
          try {
            const u = new URL(window.location.href);
            u.searchParams.delete('variant');
            window.location.replace(u.toString());
          } catch (err) {
            window.location.reload();
          }
        };
        window.addEventListener('pageshow', (e) => checkReturn(e.persisted));
        // pageshow may already have fired before this element upgraded
        if (document.readyState === 'complete') checkReturn(false);

        this.syncAtcPrice = () => {
          try {
            const atcPriceEl = this.querySelector('.atc-button-price');
            if (!atcPriceEl) return;

            const sectionId = this.dataset.sectionId;
            const sectionRoot = sectionId ? document.getElementById(`shopify-section-${sectionId}`) : null;
            const sellingPlanRoot = (sectionRoot || document).querySelector('.selling-plan-block');
            if (!sellingPlanRoot) return;

            const checked = (sectionRoot || document).querySelector('input[name="selling_plan"]:checked');
            const checkedValue = checked ? String(checked.value || '') : null;
            const hasChecked = !!checked;
            const isOneTimeSelected = hasChecked && checkedValue === '';
            const isSubscriptionSelected = hasChecked && checkedValue !== '';

            if (isSubscriptionSelected) {
              let activeCard = sellingPlanRoot.querySelector('.sp-card.sp-card--active');
              if (activeCard && checkedValue && String(activeCard.getAttribute('data-selling-plan-id') || '') !== checkedValue) {
                activeCard = null;
              }
              if (!activeCard && checkedValue) {
                activeCard = sellingPlanRoot.querySelector(`.sp-card[data-selling-plan-id="${checkedValue}"]`);
              }
              const plan = activeCard ? String(activeCard.getAttribute('data-plan') || '') : '';
              const key = plan === '2' ? 'plan2' : plan === '3' ? 'plan3' : 'plan1';
              const priceSource = sellingPlanRoot.querySelector(`[data-price-key="${key}"]`);
              const txt = priceSource ? String(priceSource.textContent || '').trim() : '';
              const next = txt ? `\u00A0${txt}` : '';
              if (next) {
                atcPriceEl.textContent = next;
                this._lastAtcPriceText = next;
              } else if (this._lastAtcPriceText) {
                atcPriceEl.textContent = this._lastAtcPriceText;
              }
              return;
            }

            if (isOneTimeSelected) {
              const oneTimeSource = sellingPlanRoot.querySelector('[data-price-key="oneTime"]');
              const oneTimeTxt = oneTimeSource ? String(oneTimeSource.textContent || '').trim() : '';
              const next = oneTimeTxt ? `\u00A0${oneTimeTxt}` : '';
              if (next) {
                atcPriceEl.textContent = next;
                this._lastAtcPriceText = next;
              } else if (this._lastAtcPriceText) {
                atcPriceEl.textContent = this._lastAtcPriceText;
              }
              return;
            }

            const activeCard = sellingPlanRoot.querySelector('.sp-card.sp-card--active');
            if (activeCard) {
              const plan = String(activeCard.getAttribute('data-plan') || '');
              const key = plan === '2' ? 'plan2' : plan === '3' ? 'plan3' : 'plan1';
              const priceSource = sellingPlanRoot.querySelector(`[data-price-key="${key}"]`);
              const txt = priceSource ? String(priceSource.textContent || '').trim() : '';
              const next = txt ? `\u00A0${txt}` : '';
              if (next) {
                atcPriceEl.textContent = next;
                this._lastAtcPriceText = next;
                return;
              }
            }

            if (this._lastAtcPriceText) {
              atcPriceEl.textContent = this._lastAtcPriceText;
            }
          } catch (e) {}
        };

        this._syncAtcPriceHandler = (e) => {
          try {
            if (!e || !e.target) return;
            if (e.target.name === 'selling_plan' || e.target.closest('variant-selects') || e.target.closest('.selling-plan-block')) {
              this.syncAtcPrice();
              setTimeout(this.syncAtcPrice, 250);
              setTimeout(this.syncAtcPrice, 700);
              setTimeout(this.syncAtcPrice, 1300);
            }
          } catch (err) {}
        };
        document.addEventListener('change', this._syncAtcPriceHandler);
        setTimeout(this.syncAtcPrice, 0);
        setTimeout(this.syncAtcPrice, 600);
        setInterval(this.syncAtcPrice, 600);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const suppressLoading = this.dataset.suppressLoading === 'true';
        if (suppressLoading) delete this.dataset.suppressLoading;

        if (suppressLoading) {
          if (this._oneTimeSubmitting) return;
          this._oneTimeSubmitting = true;
        } else {
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        }

        this.handleErrorMessage();

        let oneTimeButton = null;
        let oneTimeButtonSpinner = null;
        let oneTimeLabelEl = null;
        let oneTimePriceEl = null;
        let oneTimePrevPointerEvents = null;
        let oneTimePrevLabelVisibility = null;
        let oneTimePrevPriceVisibility = null;
        if (suppressLoading) {
          const sectionId = this.dataset.sectionId;
          const sectionRoot = sectionId ? document.getElementById(`shopify-section-${sectionId}`) : null;
          oneTimeButton = sectionRoot ? sectionRoot.querySelector('[data-selling-plan-one-time]') : null;
          if (oneTimeButton) {
            oneTimeButtonSpinner = oneTimeButton.querySelector('.loading__spinner');
            if (oneTimeButtonSpinner) oneTimeButtonSpinner.classList.remove('hidden');
            oneTimeLabelEl = oneTimeButton.querySelector('.selling-plan-block__one-time-label');
            oneTimePriceEl = oneTimeButton.querySelector('.selling-plan-block__one-time-price');
            if (oneTimeLabelEl) {
              oneTimePrevLabelVisibility = oneTimeLabelEl.style.visibility;
              oneTimeLabelEl.style.visibility = 'hidden';
            }
            if (oneTimePriceEl) {
              oneTimePrevPriceVisibility = oneTimePriceEl.style.visibility;
              oneTimePriceEl.style.visibility = 'hidden';
            }
            oneTimePrevPointerEvents = oneTimeButton.style.pointerEvents;
            oneTimeButton.style.pointerEvents = 'none';
            oneTimeButton.setAttribute('aria-busy', 'true');
          }
        } else {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          const spinner = this.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');
        }

        const directCheckout = this.dataset.directCheckout === 'true';
        const goToCheckout = () => {
          // Drop ?variant= so Back doesn't land on the previous pack size,
          // and flag the return so we can reset the picker.
          try {
            sessionStorage.setItem('vyve_dc_return', '1');
            const u = new URL(window.location.href);
            if (u.searchParams.has('variant')) { u.searchParams.delete('variant'); history.replaceState(null, '', u.toString()); }
          } catch (e) {}
          window.location.href = this.dataset.checkoutUrl || '/checkout';
        };
        const renderCartResponse = (response) => {
          if (directCheckout) { goToCheckout(); return; }
          if (!this.cart) return;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(response);
                  });
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            CartPerformance.measure("add:paint-updated-sections", () => {
              this.cart.renderContents(response);
            });
          }
        };

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // SOURCE-OF-TRUTH VARIANT: the hidden name="id" input is written
        // asynchronously from fetched section HTML and can lag or go stale
        // (Back navigation, rapid clicks, aborted requests). Resolve the
        // variant from the radios actually checked on screen instead.
        try {
          const sid = this.dataset.sectionId;
          const vs = sid ? document.getElementById(`variant-selects-${sid}`) : null;
          const dataEl = sid ? document.getElementById(`product-variants-metafields-${sid}`) : null;
          if (vs && dataEl) {
            const variants = JSON.parse(dataEl.textContent || '[]');
            const opts = Array.from(vs.querySelectorAll('fieldset')).map((fs) => {
              const ch = fs.querySelector('input[type="radio"]:checked');
              if (ch) return ch.value;
              const sel = fs.querySelector('select');
              return sel ? sel.value : null;
            });
            if (opts.length && opts.every(Boolean)) {
              const match = variants.find((v) => Array.isArray(v.options) && v.options.length === opts.length && v.options.every((o, i) => o === opts[i]));
              if (match && match.id) {
                formData.set('id', String(match.id));
                const idInput = this.form.querySelector('input[name="id"]');
                if (idInput) { idInput.value = String(match.id); idInput.disabled = false; }
              }
            }
          }
        } catch (e) {}

        try {
          const sectionId = this.dataset.sectionId;
          const variantSelects = sectionId ? document.getElementById(`variant-selects-${sectionId}`) : null;
          const hasPackQuantityOption =
            !!(variantSelects && variantSelects.querySelector('.Quantity-block, .quantity-block'));
          if (hasPackQuantityOption) {
            formData.set('quantity', '1');
          }
        } catch (e) {}

        const forceOneTime = this.dataset.forceOneTime === 'true';
        if (forceOneTime) delete this.dataset.forceOneTime;
        const isOneTimeDirectAdd = this.dataset.oneTime === 'true' || forceOneTime;

        let selectedSellingPlanId = null;
        if (!isOneTimeDirectAdd) {
          try {
            const sectionId = this.dataset.sectionId;
            const sectionRoot = sectionId ? document.getElementById(`shopify-section-${sectionId}`) : null;
            const checkedSellingPlan =
              this.form.querySelector('input[name="selling_plan"]:checked') ||
              (sectionRoot ? sectionRoot.querySelector('input[name="selling_plan"]:checked') : null) ||
              document.querySelector('input[name="selling_plan"]:checked');
            selectedSellingPlanId = checkedSellingPlan ? String(checkedSellingPlan.value || '') : null;
            if (selectedSellingPlanId) {
              formData.set('selling_plan', selectedSellingPlanId);
            } else {
              formData.delete('selling_plan');
            }
          } catch (e) {}
        } else {
          formData.delete('selling_plan');
        }

        let giftVariantIds = [];
        if (!isOneTimeDirectAdd) {
          try {
            if (selectedSellingPlanId) {
              const sectionId = this.dataset.sectionId;
              const sectionRoot = sectionId ? document.getElementById(`shopify-section-${sectionId}`) : null;
              const sellingPlanRoot = sectionRoot ? sectionRoot.querySelector('.selling-plan-block') : null;
              let planCard = sellingPlanRoot ? sellingPlanRoot.querySelector('.sp-card.sp-card--active') : null;
              if (planCard && String(planCard.getAttribute('data-selling-plan-id') || '') !== String(selectedSellingPlanId)) {
                planCard = null;
              }
              if (!planCard && sellingPlanRoot) {
                planCard = sellingPlanRoot.querySelector(`.sp-card[data-selling-plan-id="${selectedSellingPlanId}"]`);
              }
              const rawGiftIds = planCard ? planCard.getAttribute('data-gift-variant-ids') : '';
              giftVariantIds = String(rawGiftIds || '')
                .split(',')
                .map((s) => s.trim())
                .filter((s) => s && /^\d+$/.test(s));
            }
          } catch (e) {}
        }

        if (this.cart && !directCheckout) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        if (directCheckout) window.__vyveDirectCheckout = true;
        config.body = formData;

        const clearFirst = directCheckout && this.dataset.checkoutClearCart === 'true';
        const preAdd = clearFirst
          ? fetch(`${routes.cart_url}/clear.js`, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' } }).catch(() => {})
          : Promise.resolve();

        preAdd
          .then(() => fetch(`${routes.cart_add_url}`, config))
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (directCheckout) {
              // Direct-to-checkout: never publish cartUpdate (the drawer listens
              // for it and would open). Add gifts if needed, then navigate.
              if (selectedSellingPlanId && giftVariantIds.length) {
                const giftConfig = fetchConfig('javascript');
                giftConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete giftConfig.headers['Content-Type'];
                const giftFormData = new FormData();
                giftVariantIds.forEach((id, idx) => {
                  giftFormData.append(`items[${idx}][id]`, id);
                  giftFormData.append(`items[${idx}][quantity]`, '1');
                  giftFormData.append(`items[${idx}][properties][_free_gift]`, 'true');
                  giftFormData.append(`items[${idx}][properties][_gift_for_selling_plan]`, selectedSellingPlanId);
                });
                giftConfig.body = giftFormData;
                return fetch(`${routes.cart_add_url}`, giftConfig).catch(() => {}).then(goToCheckout);
              }
              goToCheckout();
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;

            if (selectedSellingPlanId && giftVariantIds.length) {
              const giftConfig = fetchConfig('javascript');
              giftConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete giftConfig.headers['Content-Type'];

              const giftFormData = new FormData();
              giftVariantIds.forEach((id, idx) => {
                giftFormData.append(`items[${idx}][id]`, id);
                giftFormData.append(`items[${idx}][quantity]`, '1');
                giftFormData.append(`items[${idx}][properties][_free_gift]`, 'true');
                giftFormData.append(`items[${idx}][properties][_gift_for_selling_plan]`, selectedSellingPlanId);
              });

              if (this.cart) {
                giftFormData.append(
                  'sections',
                  this.cart.getSectionsToRender().map((section) => section.id)
                );
                giftFormData.append('sections_url', window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
              }

              giftConfig.body = giftFormData;

              return fetch(`${routes.cart_add_url}`, giftConfig)
                .then((r) => r.json())
                .then((giftResponse) => {
                  if (giftResponse && giftResponse.status) {
                    renderCartResponse(response);
                    return;
                  }
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    cartData: giftResponse,
                  });
                  renderCartResponse(giftResponse);
                })
                .catch(() => {
                  renderCartResponse(response);
                });
            }

            renderCartResponse(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (suppressLoading) {
              this._oneTimeSubmitting = false;
              if (oneTimeButton) {
                if (oneTimeButtonSpinner) oneTimeButtonSpinner.classList.add('hidden');
                if (oneTimeLabelEl) oneTimeLabelEl.style.visibility = oneTimePrevLabelVisibility || '';
                if (oneTimePriceEl) oneTimePriceEl.style.visibility = oneTimePrevPriceVisibility || '';
                oneTimeButton.style.pointerEvents = oneTimePrevPointerEvents || '';
                oneTimeButton.removeAttribute('aria-busy');
              }
            } else {
              this.submitButton.classList.remove('loading');
            }
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!suppressLoading && !this.error) this.submitButton.removeAttribute('aria-disabled');
            if (!suppressLoading) {
              const spinner = this.querySelector('.loading__spinner');
              if (spinner) spinner.classList.add('hidden');
            }

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form ? this.form.querySelector('[name=id]') : null;
      }
    }
  );
}
